/* TotalPantofi - fereastra de cautare din antet (04.11.2026).
   - campul primeste focus imediat la deschidere (si pe telefon se deschide tastatura), cu reincercari daca browserul intarzie
   - cand campul e gol: "Cautate recent" (pastrate doar in acest browser), "Populare", "Branduri" (HTML-ul e in snippets/header-search.liquid)
   - scurtaturi: "/" sau Ctrl/Cmd+K deschid cautarea (desktop)
   Revenire: scoate liniile tp-searchux.* din layout/theme.liquid. */
(function () {
  'use strict';
  var KEY = 'tp_recent_q', MAX = 6;
  function safe(f, d) { try { return f(); } catch (e) { return d; } }
  function recent() {
    return safe(function () {
      var a = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(a) ? a.filter(function (x) { return typeof x === 'string' && x.trim(); }).slice(0, MAX) : [];
    }, []);
  }
  function save(q) {
    q = String(q == null ? '' : q).trim().replace(/\s+/g, ' ');
    if (q.length < 2 || q.length > 60) return;
    var a = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    a.unshift(q);
    safe(function () { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); });
  }
  window.tpRecentSave = save;
  function urlFor(q) {
    var b = safe(function () { return window.tpBrandUrl ? window.tpBrandUrl(q) : null; }, null);
    return b ? b[1] : '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
  }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function parts(modal) {
    var det = $('details', modal);
    return { det: det, input: $('input[name="q"]', modal), panel: $('[data-tp-sq]', modal) };
  }
  function renderRecent(modal) {
    var p = parts(modal);
    var sec = $('[data-tp-sq-recent]', modal), list = $('[data-tp-sq-recent-list]', modal);
    if (!p.panel || !sec || !list) return;
    var r = recent();
    list.textContent = '';
    r.forEach(function (q) {
      var a = document.createElement('a');
      a.className = 'tp-sq__chip tp-sq__chip--recent';
      a.href = urlFor(q);
      a.textContent = q;
      a.setAttribute('data-tp-sq-term', q);
      list.appendChild(a);
    });
    sec.hidden = !r.length;
  }
  function sync(modal) {
    var p = parts(modal);
    if (!p.panel || !p.input) return;
    p.panel.hidden = !(p.det && p.det.open && !p.input.value.trim());
  }
  function focusInput(modal) {
    var p = parts(modal);
    if (!p.input) return;
    var tries = 0;
    (function go() {
      if (!p.det.open) return;
      if (document.activeElement === p.input) return;
      var a = document.activeElement;
      if (tries > 0 && a && a !== document.body && a.tagName !== 'SUMMARY' && p.det.contains(a)) return;   /* clientul si-a mutat deja focusul in fereastra */
      p.input.focus({ preventScroll: true });
      if (document.activeElement === p.input) {
        if (p.input.value) { try { p.input.setSelectionRange(0, p.input.value.length); } catch (e) {} }
        return;
      }
      if (++tries < 8) setTimeout(go, tries < 3 ? 30 : 90);
    })();
  }
  function onOpen(modal) {
    renderRecent(modal);
    sync(modal);
    focusInput(modal);
  }

  function wire(modal) {
    if (modal.__tpSq) return; modal.__tpSq = true;
    var p = parts(modal);
    if (!p.det || !p.input) return;
    p.det.addEventListener('toggle', function () { if (p.det.open) onOpen(modal); else sync(modal); });
    var s = $('summary', modal);
    if (s) s.addEventListener('click', function () { setTimeout(function () { if (p.det.open) onOpen(modal); }, 0); });
    p.input.addEventListener('input', function () { sync(modal); });
    var form = p.input.form;
    if (form) {
      form.addEventListener('reset', function () { setTimeout(function () { sync(modal); p.input.focus({ preventScroll: true }); }, 0); });
      form.addEventListener('submit', function () { save(p.input.value); }, true);
    }
    modal.addEventListener('click', function (e) {
      var chip = e.target.closest && e.target.closest('[data-tp-sq-term]');
      if (chip) save(chip.getAttribute('data-tp-sq-term'));
      var clr = e.target.closest && e.target.closest('[data-tp-sq-clear]');
      if (clr) { safe(function () { localStorage.removeItem(KEY); }); renderRecent(modal); }
    });
    if (p.det.open) onOpen(modal);
  }
  function init() { $$('details-modal.header__search').forEach(wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* "/" sau Ctrl/Cmd+K deschid cautarea, doar cand nu scrii deja intr-un camp */
  document.addEventListener('keydown', function (e) {
    var k = e.key;
    var isSlash = k === '/' && !e.ctrlKey && !e.metaKey && !e.altKey;
    var isK = (k === 'k' || k === 'K') && (e.ctrlKey || e.metaKey) && !e.altKey;
    if (!isSlash && !isK) return;
    var a = document.activeElement;
    if (isSlash && a && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable)) return;
    var s = $$('details-modal.header__search summary').find(function (x) { return x.offsetParent !== null; });
    if (!s) return;
    var det = s.closest('details');
    if (det && det.open) { if (isK) e.preventDefault(); return; }
    e.preventDefault();
    s.click();
  });
})();
